import { useMutation } from 'react-query';
import { rollbackDemand } from 'src/services/api/demands';

function useRollbackDemand() {
  return useMutation(({ demandId }) => rollbackDemand(demandId));
}

export default useRollbackDemand;
